module.exports = __webpack_public_path__ + "static/media/readAll.7163b2fb.svg";